<template>
  <v-dialog v-model="open" persistent content-class="recognition-dialog">
    <v-card>
      <v-card-title v-if="step === 'uploading' || step === 'recognizing' || step === 'searching_client' || step === 'searching_vehicle'">
        <div class="info-alert">
          <b>DICA:</b> Sempre registre a foto traseira por último.
        </div>
        <v-img
          v-if="media"
          max-height="200"
          width="100%"
          :src="media.photo_url"
          :class="{ 'uploading-img': step === 'uploading' }"
          style="border-radius: 6px;"
        >
          <img class="recognition-animation" v-if="step === 'recognizing' || step === 'searching_client' || step === 'searching_vehicle'" :src="require('@/assets/plate_recognizer/recognizing.gif')">
        </v-img>
      </v-card-title>
      <v-card-title v-if="step === 'select_plate_vehicle'">
        <div style="font-size: 14px; text-align: center; width: 100%; font-weight: 500;">
          Identificamos mais de uma placa na foto, por favor, selecione a placa correta:
        </div>
      </v-card-title>
      <v-card-title v-if="step === 'type_plate'">
        <div class="info-alert">
          Por favor, digite a placa abaixo:
        </div>
        <div style="width: 60%; float: left;">
          <v-text-field
            v-model="type_plate"
            @keyup="uppercaseVehiclePlate"
            placeholder="ABC1234"
            hide-details
            filled
          ></v-text-field>
        </div>
        <div style="width: 40%; float: left; padding-left: 10px">
          <v-btn @click="typePlateSearch()" depressed color="primary" style="width: -webkit-fill-available; height: 56px;">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>
        <div style="width: 100%; margin-top: 18px;">
          <v-btn @click="closeDialog()" block small depressed>
            CANCELAR
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="mt-1 pb-1">
        <div v-if="step === 'select_plate'" class="plate-selection">
          <div style="font-size: 14px; margin-bottom: 12px; text-align: center;">SELECIONE ABAIXO A PLACA CORRETA:</div>
          <v-btn v-for="plate in vehicle_plates" :key="plate" @click="checkVehicleClient(plate)" depressed dark block large color="#48B48D" class="my-2" style="font-size: 16px">
            {{ plate.toUpperCase() }}
          </v-btn>
          <div style="overflow: hidden; position: relative; padding: 10px 0px; padding-top: 16px; margin-bottom: 10px;">
            <hr class="mb-3"/>
            <div style="background-color: rgb(255, 255, 255); margin: 0px auto; width: 30px; text-align: center; margin-top: -24px;">OU</div>
          </div>
          <v-btn @click="setTypePlateMethod()" block small depressed>
            DIGITAR PLACA MANUALMENTE
          </v-btn>
        </div>
        <div v-if="step === 'select_plate_vehicle'" class="plate-selection">
          <v-btn v-for="plate in vehicle_plates" :key="plate" @click="selectVehiclePlate(plate)" depressed dark block large color="#48B48D" class="my-2" style="font-size: 16px">
            {{ plate.toUpperCase() }}
          </v-btn>
        </div>
        <div v-if="loading.status" class="item-log">
          <div class="item-icon">
            <v-progress-circular
              size="28"
              class="mr-1"
              indeterminate
              color="#48B48D"
            ></v-progress-circular>
          </div>
          <div class="item-description">
            {{ loading.text }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  </template>

  <script>
  import Thumbor from 'thumbor-js-url-builder';

  export default {
    props: {
      open: Boolean,
      media: {
        type: null,
      },
    },
    data: () => ({
      media_created_id: null,
      step: 'uploading',
      loading: {
        status: true,
        text: 'Enviando foto para nuvem...',
      },
      vehicle_plates: [],
      vehicle_selected_plate: null,
      vehicle_data: null,
      type_plate: null,
    }),
    methods: {
      closeDialog() {
        this.media_created_id = null;
        this.step = 'uploading';
        this.loading = {
          status: true,
          text: 'Enviando foto para nuvem...',
        };
        this.vehicle_plates = [];
        this.vehicle_selected_plate = null;
        this.vehicle_data = null;
        this.type_plate = null;
        this.$emit('close');
      },
      recognizePlate() {
        const self = this;

        const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
        const thumborPhoto = thumbor.setImagePath(self.media.photo_url_cloud).resize(720, 0).buildUrl();

        self.$http
          .post(`/recognize_plate/photo`, { photo_url: thumborPhoto })
          .then((r) => {
            self.loading.status = false;
            if (r.data.plates.length === 0) {
              self.closeDialog();
              self.$toast.error('Não foi possivel identificar a placa');
            } else if (r.data.plates.length === 1) {
              if (self.validateVehiclePlate(r.data.plates[0])) {
                self.checkVehicleClient(r.data.plates[0]);
              } else {
                self.setTypePlateMethod();
              }
            } else {
              self.step = 'select_plate';
              self.vehicle_plates = r.data.plates;
            }
          });
      },
      checkVehicleClient(plate) {
        this.loading = {
          status: true,
          text: 'Verificando cadastro de clientes...',
        };
        this.step = 'searching_client';

        const self = this;
          self.$http
            .get(`/recognize_plate/check_vehicle_client/${plate}`)
            .then((r) => {
              if (r.data.vehicle) {
                setTimeout(() => {
                  self.$store.dispatch('ServiceOrder/setClientByVehiclePlate', r.data);
                }, 1000);
              } else {
                self.$emit('newClientCallback', r.data);
              }
              self.closeDialog();
            });
      },
      validateVehiclePlate(plate) {
          plate = plate.toUpperCase().replace(/[\s-]/g, '');
          const padraoAntigo = /^[A-Z]{3}\d{4}$/;
          const padraoMercosul = /^[A-Z]{3}\d[A-Z]\d{2}$/;
          return padraoAntigo.test(plate) || padraoMercosul.test(plate);
      },
      setTypePlateMethod() {
        this.type_plate = null;
        this.step = 'type_plate';
      },
      uppercaseVehiclePlate() {
        this.type_plate = this.type_plate.toUpperCase();
      },
      typePlateSearch() {
        this.checkVehicleClient(this.type_plate);
      },
      showVehiclePlates(plates) {
        this.vehicle_plates = plates;
        this.loading.status = false;
        this.step = 'select_plate_vehicle';
      },
      selectVehiclePlate(plate) {
        this.$emit('plateSelected', plate);
      }
    },
    watch: {
      open(val) {
        if (!val) {
          this.media_created_id = null;
          this.step = 'uploading';
          this.loading = { status: true, text: 'Enviando foto para nuvem...' };
          this.vehicle_plates = [];
          this.vehicle_selected_plate = null;
          this.vehicle_data = null;
          this.type_plate = null;
        }
      },
      step(val) {
        if (val === 'uploading') {
          this.loading.text = 'Enviando foto para nuvem...';
        } else if (val === 'recognizing') {
          this.loading.text = 'Identificando placa do veículo...';
          setTimeout(() => {
            this.recognizePlate();
          }, 600);
        }
      },
    },
  };
  </script>

<style lang="scss">
.recognition-dialog {

  .uploading-img {
    opacity: 0.4;
  }

  .info-alert {
    font-size: 12px;
    text-align: center;
    width: -webkit-fill-available;
    margin-bottom: 10px;
    background-color: #fffaf0;
    color: #ed903d;
  }

  .recognition-animation {
    width: -webkit-fill-available;
  }

  .plate-selection {
    padding-top: 10px;
    padding-bottom: 8px;
  }

  .item-log {
    overflow: hidden;
    background-color: #ededed;
    border-radius: 6px;
    padding: 14px;
    margin-bottom: 14px;

    .item-icon {
      float: left;
      margin-right: 16px;
    }

    .item-description {
      float: left;
      font-size: 14px;
      font-weight: 500;
      margin-top: 4px;
      color: rgba(0, 0, 0, .6) !important;
    }
  }
}
</style>
